export const ALGOLIA_CATEGORY_SEPARATOR = ' > '
